import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Loader from "components/Loader/index";

import GridWrapper from "custom-hooks/GridWrapper";
import { setApi } from "reducers/grid";
import Diagram from "pages/Ordering/common/Diagram";

import Filters from "./Filters";

import baseService from "../../../../services/BaseService";
import { isEmpty } from "lodash";

const DEFAULT_FILTERS = [{ code: "query", name: "Пошук", search: false, type: "STRING" }];

const mapStateToProps = state => {
    return {
        grids: state.grid,
    };
};

const SpecList = props => {
    const {
        gridUrlKey = "customer_grid_with_filters",
        history,
        updateApiGrid,
        itemId,
        itemType,
        code,
        // match: {
        //     params: { id: customerId },
        // },
        fixedFilterObject,
        initSort,
        gridConfigCode,
        tabNum,
        gridCustomType,
        gridCustomCode,
        gridType,
        gridConfigKey,
        grids,
        onGridExport,
        customerId,
        contactPersonId,
        historyPath,
        onGridFloatingButtonClick,
        shouldIncludeCustomersId,
    } = props;

    // const DEFAULT_TYPE = code.toUpperCase();
    // const TYPE = gridConfigCode || DEFAULT_TYPE;
    const TYPE = gridCustomType || code.toUpperCase();

    // const CODE = gridConfigCode || `CUSTOMER_${DEFAULT_TYPE}_TAB`;
    const CODE = gridConfigCode || `CUSTOMER_${TYPE}_TAB`;
    

    // const GRID_CODE = gridCustomCode || gridConfigCode || `CUSTOMER_${TYPE}_TAB`;

    const OBJECT_TYPE = gridCustomCode || TYPE;

    const [loadingState, setLoadingState] = useState(true);
    const [isFiltersLoading, setIsFiltersLoading] = useState(true);
    const [hiddenFilters, setHiddenFilters] = useState([]);
    const [mainFilters, setMainFilters] = useState([]);
    const [secondaryFilters, setSecondaryFilters] = useState([]);
    const [showSecondaryFilters, setShowSecondaryFilters] = useState(false);
    const [gridFilters, setGridFilters] = useState({});


    const init = {
        method: "post",
        key: gridUrlKey,
        code: CODE,
        type: gridType, //"spec",
        pathParams: { customerId, objectType: OBJECT_TYPE, contactPersonId },
        extra: itemId ? `${TYPE}_${itemType}_${itemId}.${customerId}` : `${TYPE}_${customerId}`,
        ...gridFilters,
        // isDynamic: true,
        configUrlKey: "config_grid",
        // configKey: gridCustomType  || "service", // configKey: 'resource',
        configKey: gridConfigKey || gridType,
        // configCode: TYPE,
        configCode: gridConfigCode || gridCustomCode ||  TYPE,
    };
    if (tabNum) {
        init.extra = `${init.extra}_${tabNum}`;
    }
    if (contactPersonId) {
        init.extra = `${init.extra}_${contactPersonId}`;
    }
    if (initSort && initSort[0]) {
        init.sort = initSort;
        init.field = initSort[0].property;
        init.order = initSort[0].direction;
    }

    const gridKey = `${init.key}_${init.path || init.extra || ""}`;

    const getParams = () => ({
        selectItem: item => history.push(`/${historyPath || code}/${item.id}`),
        // selectItem: (item) => history.push(`/resource/${item.id}`),
        fields: {
            hasFlow: {
                component: Diagram,
            },
        },
    });

    const onStart = () => setLoadingState(true);

    const onFinish = () => setLoadingState(false);

    function handleGridExport() {
        onGridExport(grids[gridKey])
    }

    function toggleSecondaryFilters() {
        setShowSecondaryFilters(prev => !prev);
    }

    // to prevent grid double requests - get filters first, after init grid with filters data
    useEffect(() => {
        const data = { code: CODE, idHashKeyRequest: "" };
        // TODO: Notice
        // we are getting some def values in filters via that ID's (def_value inside of ./Filters.js)
        // we should get it the same way once migrated to the new ordering widgets
        if (shouldIncludeCustomersId) {
            if (customerId) {
                data.customer = customerId;
            }
            if (contactPersonId) {
                data.person = contactPersonId;
            }
        }
        baseService
            .get("attributes", { data })
            .then(({ result }) => {
                const allFilters = [...DEFAULT_FILTERS, ...result].filter(filter => !filter.hidden);
                let newMainFilters = allFilters;
                let newSecondaryFilters = [];
                if (newMainFilters.length > 4) {
                    newMainFilters = allFilters.slice(0, 4);
                    newSecondaryFilters = allFilters.slice(4, allFilters.length);
                }
                setMainFilters(newMainFilters);
                setSecondaryFilters(newSecondaryFilters);
                const newHiddenFilters = result.filter(filter => filter.hidden);
                setHiddenFilters(newHiddenFilters);
                setIsFiltersLoading(false);
            })
            .catch(e => setIsFiltersLoading(false));
    }, []);

    useEffect(() => {
        // console.log({UPDATE_CUSTOMER_ID: customerId, gridFilters});
        customerId && !isEmpty(gridFilters) &&
            updateApiGrid(
                {
                    pathParams: { customerId, objectType: OBJECT_TYPE, contactPersonId },
                    ...gridFilters,
                },
                gridKey
            );

    }, [customerId, gridFilters]);

    useEffect(() => {
        if (itemId) {
            setShowSecondaryFilters(false);
        }
    }, [itemId]);



    return (
        <div
            className={`content-wrapper ordering-component-ui-core-wrapper with-fixed-status with-filters ${showSecondaryFilters &&
                "with-secondary-filters"} ${secondaryFilters.length === 0 && "without-secondary-filters"}`}
        >
            {customerId && (
                <Filters
                    code={code}
                    id={itemId}
                    itemType={itemType}
                    customerId={customerId}
                    isLoading={isFiltersLoading}
                    mainFilters={mainFilters}
                    secondaryFilters={secondaryFilters}
                    hiddenFilters={hiddenFilters}
                    gridFilters={gridFilters}
                    setGridFilters={setGridFilters}
                    toggleSecondaryFilters={toggleSecondaryFilters}
                    fixedFilterObject={fixedFilterObject}
                    tabNum={tabNum}
                    key={`${itemId}.${customerId}`}
                />
            )}
            {(loadingState || isFiltersLoading) && <Loader />}
            {!isEmpty(gridFilters) && (
                <GridWrapper
                    tuner={() => init}
                    initUpdate={false}
                    gridParams={getParams()}
                    onStart={onStart}
                    onFinish={onFinish}
                    onGridExport={onGridExport && handleGridExport}
					fieldsLsCacheKey={`customer_page_${gridConfigKey || gridType}`}
                    sortFieldsLsCacheKey={`customer_page_${gridKey}`}
                    onGridFloatingButtonClick={onGridFloatingButtonClick}
                />
            )}
        </div>
    );
};

export default connect(mapStateToProps, { updateApiGrid: setApi })(withRouter(SpecList));
